<template>
  <div class="min-h-screen bg-slate-50 dark:bg-slate-900">
    <slot />
  </div>
</template>
<script setup>
</script>
